import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import _ from 'lodash';
import { connect } from 'react-redux';
// local
// views
import EmptyList from 'app/ui/commons/emptyList/EmptyList';
import TableHeaderCellSort from 'app/ui/commons/TableHeaderCellSort';
import TabTableRow from './TabTableRow';
// actions
import { sort } from 'app/redux/actions/editConfirm/data';

class TabDelivered extends Component {
    onClickSort = newColumn => () => {
        let { column, direction } = this.props.editConfirm.sort.delivered;
        if (newColumn !== column) {
            column = newColumn;
            direction = 'ascending';
        } else {
            direction = direction === 'ascending' ? 'descending' : 'ascending';
        }
        this.props.dispatch(sort('delivered', column, direction));
    };

    renderEmpty = () => <EmptyList emptyMessage="Nenhum histórico de consumo computado." />;

    renderTable(delivered, sort) {
        return (
            <Table sortable>
                <Table.Header>
                    <Table.Row>
                        <TableHeaderCellSort
                            title="Data"
                            column="replacementConfirmed"
                            sort={sort.delivered}
                            onClick={this.onClickSort('replacementConfirmed')}
                            style={{ width: '120px' }}
                        />
                        <TableHeaderCellSort title="PACIENTE" column="patient.name" sort={sort.delivered} onClick={this.onClickSort('patient.name')} />
                        <TableHeaderCellSort
                            title="FORNECEDOR"
                            column="supplier.name"
                            sort={sort.delivered}
                            onClick={this.onClickSort('supplier.name')}
                            style={{ textAlign: 'center' }}
                        />
                        <Table.HeaderCell style={{ width: '120px', textAlign: 'center' }}>SOLICITADOS</Table.HeaderCell>
                        <Table.HeaderCell style={{ width: '120px', textAlign: 'center' }}>ENTREGUES</Table.HeaderCell>
                        <Table.HeaderCell style={{ width: '90px' }} />
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {_.map(delivered, row => {
                        const key = _.uniqueId('delivered_');
                        return <TabTableRow key={key} stateKey="delivered" row={row} canEdit={row.isLast ? true : false} />;
                    })}
                </Table.Body>
            </Table>
        );
    }

    render() {
        const { delivered, sort } = this.props.editConfirm;
        return _.isEmpty(delivered) ? this.renderEmpty() : this.renderTable(delivered, sort);
    }
}

TabDelivered.propTypes = {
    dispatch: PropTypes.func,
    editConfirm: PropTypes.object,
};

const mapStateToProps = state => ({
    editConfirm: state.editConfirm,
});
export default connect(mapStateToProps)(TabDelivered);
